import { render, staticRenderFns } from "./Loginav.vue?vue&type=template&id=62cd95f8"
import script from "./Loginav.vue?vue&type=script&lang=js"
export * from "./Loginav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports